import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleCountryDuration extends TitleBase {
	private countryValue: string;
	private durationValue: string;

	protected canHandle(): boolean {
		this.countryValue = this.getFilterValue(ParameterType.COUNTRY);
		this.durationValue = this.getFilterValue(ParameterType.DURATION);

		return (
			this.indexableFilters.length === 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY) &&
			this.indexableFilters.some((_) => _.type === ParameterType.DURATION)
		);
	}

	protected getPageTitle(): string {
		return `${this.durationValue} ${this.titlePortalType} in ${this.countryValue}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(`${this.durationValue.toLowerCase()} ${this.titlePortalType}`, ` in ${this.countryValue}`);
	}
}
